import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17af9aca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "availability-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Availability", -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "search-form" }
const _hoisted_5 = { class: "form-row" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Arrival Date", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Departure Date", -1))
const _hoisted_10 = { class: "form-row" }
const _hoisted_11 = { class: "form-group category-field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Category "),
  /*#__PURE__*/_createElementVNode("span", { class: "required-mark" }, "*")
], -1))
const _hoisted_13 = {
  value: "",
  disabled: ""
}
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "form-row" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Adults", -1))
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Children", -1))
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Animals", -1))
const _hoisted_22 = { class: "form-row" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Site Length (optional)", -1))
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Site Width (optional)", -1))
const _hoisted_27 = { class: "form-row" }
const _hoisted_28 = { class: "form-group discount-field" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Discount Code or Name (optional)", -1))
const _hoisted_30 = { class: "form-row form-row--equipment" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Equipment Length (optional)", -1))
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Equipment Width (optional)", -1))
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Equipment Height (optional)", -1))
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Slideouts (optional)", -1))
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-17af9aca>Any</option><option value=\"none\" data-v-17af9aca>None</option><option value=\"passenger_side\" data-v-17af9aca>Passenger Side</option><option value=\"driver_side\" data-v-17af9aca>Driver Side</option><option value=\"both_sides\" data-v-17af9aca>Both Sides</option>", 5)
const _hoisted_44 = [
  _hoisted_39
]
const _hoisted_45 = {
  key: 2,
  class: "results-block"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Available Sites", -1))
const _hoisted_47 = { class: "table-wrap" }
const _hoisted_48 = { style: {"min-width":"900px"} }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Site Name")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Category")
  ]),
  /*#__PURE__*/_createElementVNode("th", null, [
    /*#__PURE__*/_createElementVNode("h3", null, "Pricing")
  ])
], -1))
const _hoisted_50 = { class: "site-cell" }
const _hoisted_51 = {
  key: 0,
  class: "site-details"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", null, "More Details", -1))
const _hoisted_53 = { class: "site-detail__list" }
const _hoisted_54 = { class: "category-cell" }
const _hoisted_55 = { class: "pricing-cell" }
const _hoisted_56 = { class: "pricing-option__line" }
const _hoisted_57 = {
  key: 0,
  class: "pricing-option__nightly"
}
const _hoisted_58 = {
  key: 1,
  class: "pricing-option__title"
}
const _hoisted_59 = {
  key: 0,
  class: "pricing-option__desc"
}
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Book this rate ")
const _hoisted_61 = {
  key: 1,
  class: "pricing-option"
}
const _hoisted_62 = { class: "pricing-option__line" }
const _hoisted_63 = {
  key: 0,
  class: "pricing-option__nightly"
}
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Book ")
const _hoisted_65 = {
  key: 3,
  class: "text-center"
}

import { onMounted, ref } from "vue";
import api from "@virgodev/bazaar/functions/api";
import BaseSpinner from "@/components/BaseSpinner.vue";

interface CategoryOption {
  category_id: string | number;
  category_name: string;
}

interface AvailabilityPricingOption {
  total: string | number;
  title: string;
  description?: string;
  tariff_id?: string | number;
  tariff_applied_id?: string | number;
}

interface AvailabilitySiteRow {
  site_id: string | number;
  site_name?: string;
  name?: string;
  site_description?: string;
  site_short_description?: string;
  site_features?: string[];
  site_custom_fields?: string[];
  site_size?: {
    name?: string;
    length?: string | number;
    width?: string | number;
    height?: string | number;
    unit?: string;
  };
  category_type_name?: string;
  category_description?: string;
  category_short_description?: string;
  category_features?: string[];
  category_bedding?: string[];
  category_max_adults?: string | number;
  category_max_children?: string | number;
  category_max_animals?: string | number;
  category_max_combined?: string | number;
  category_name?: string;
  category?: string;
  price?: string | number;
  total?: string | number;
  pricing_options?: AvailabilityPricingOption[];
}


export default /*#__PURE__*/_defineComponent({
  props: {
    facilityId: null,
    facilityName: null
  },
  setup(__props: any) {

const props = __props as {
  facilityId: string;
  facilityName?: string;
}



const arrivalDate = ref("");
const departureDate = ref("");
const categoryId = ref("");
const categories = ref<CategoryOption[]>([]);
const categoriesStatus = ref("idle");
const adults = ref(1);
const children = ref(0);
const animals = ref(0);
const length = ref<number | null>(null);
const width = ref<number | null>(null);
const equipmentLength = ref<number | null>(null);
const equipmentWidth = ref<number | null>(null);
const equipmentHeight = ref<number | null>(null);
const slideouts = ref("");
const discountCode = ref("");
const status = ref("idle");
const results = ref<AvailabilitySiteRow[]>([]);
const errorMessage = ref("");

onMounted(loadCategories);

async function loadCategories() {
  categoriesStatus.value = "loading";
  try {
    const response = await api({
      url: `nb/categories/?facilityId=${props.facilityId}`,
      method: "GET",
    });
    if (response.ok) {
      categories.value = (response.body.data || []) as CategoryOption[];
    } else {
      const body = "body" in response ? response.body : undefined;
      errorMessage.value = body?.error || "Failed to load categories.";
    }
  } catch {
    errorMessage.value = "An error occurred while loading categories.";
  }
  categoriesStatus.value = "loaded";
}

function selectedNights() {
  if (!arrivalDate.value || !departureDate.value) return 0;
  const arrival = new Date(arrivalDate.value + "T00:00:00");
  const departure = new Date(departureDate.value + "T00:00:00");
  const diff = departure.getTime() - arrival.getTime();
  return diff > 0 ? Math.round(diff / 86400000) : 0;
}

function numericAmount(value: string | number | undefined | null) {
  if (value === undefined || value === null || value === "") return null;
  const parsed = Number(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
}

function money(value: string | number | undefined | null) {
  const amount = numericAmount(value);
  if (amount === null) return "-";
  return `$${amount.toFixed(amount % 1 === 0 ? 0 : 2)}`;
}

function nightlyRate(total: string | number | undefined | null) {
  const amount = numericAmount(total);
  const nights = selectedNights();
  if (amount === null || nights <= 0) return null;
  return amount / nights;
}

function siteTotal(site: AvailabilitySiteRow) {
  return site.price || site.total || null;
}

function firstText(...values: Array<string | undefined>) {
  return values.find((value) => value && value.trim()) || "";
}

function siteDescription(site: AvailabilitySiteRow) {
  return firstText(site.site_short_description, site.site_description);
}

function categoryDescription(site: AvailabilitySiteRow) {
  const description = firstText(
    site.category_short_description,
    site.category_description
  );
  return normalizeDetailText(description) ===
    normalizeDetailText(occupancyLabel(site))
    ? ""
    : description;
}

function categoryType(site: AvailabilitySiteRow) {
  return site.category_type_name || "";
}

function siteSizeLabel(site: AvailabilitySiteRow) {
  const size = site.site_size;
  if (!size) return "";
  if (size.name) return `Size: ${size.name}`;
  const dims = [size.length, size.width, size.height]
    .filter((value) => value !== undefined && value !== null && value !== "")
    .join(" x ");
  return dims ? `Size: ${dims}${size.unit ? ` ${size.unit}` : ""}` : "";
}

function normalizeDetailText(value: string) {
  return value.trim().toLowerCase().replace(/\s+/g, " ");
}

function occupancyLabel(site: AvailabilitySiteRow) {
  const occupancy: string[] = [];
  if (site.category_max_combined) {
    occupancy.push(`Sleeps ${site.category_max_combined}`);
  } else {
    if (site.category_max_adults)
      occupancy.push(`${site.category_max_adults} adults`);
    if (site.category_max_children) {
      occupancy.push(`${site.category_max_children} children`);
    }
    if (site.category_max_animals) {
      occupancy.push(`${site.category_max_animals} animals`);
    }
  }
  return occupancy.join(", ");
}

function categoryDetails(site: AvailabilitySiteRow) {
  const details: string[] = [];
  const type = categoryType(site);
  if (type) details.push(type);
  const description = categoryDescription(site);
  if (description) details.push(description);
  const occupancy = occupancyLabel(site);
  if (occupancy) details.push(occupancy);
  if (site.category_features?.length) {
    details.push(`Features: ${site.category_features.join(", ")}`);
  }
  if (site.category_bedding?.length) {
    details.push(`Bedding: ${site.category_bedding.join(", ")}`);
  }
  return details;
}

function allSiteDetails(site: AvailabilitySiteRow) {
  const details: string[] = [];
  const description = siteDescription(site);
  if (description) details.push(description);
  const size = siteSizeLabel(site);
  if (size) details.push(size);
  details.push(...categoryDetails(site));
  if (site.site_features?.length) {
    details.push(`Site features: ${site.site_features.join(", ")}`);
  }
  if (site.site_custom_fields?.length) {
    details.push(...site.site_custom_fields);
  }
  return details;
}

function bookingLinkQuery(
  site: AvailabilitySiteRow,
  opt: AvailabilityPricingOption | null
) {
  const q: Record<string, string> = {
    siteId: String(site.site_id),
    siteName: String(site.site_name || site.name || ""),
    arrival: arrivalDate.value,
    departure: departureDate.value,
    adults: String(adults.value),
    children: String(children.value),
    animals: String(animals.value),
    price: String(opt ? opt.total : site.price || site.total || ""),
  };
  if (opt?.title) {
    q.rateTitle = opt.title;
  }
  if (opt?.tariff_applied_id != null && opt.tariff_applied_id !== "") {
    q.tariffAppliedId = String(opt.tariff_applied_id);
  }
  if (opt?.tariff_id != null && opt.tariff_id !== "") {
    q.tariffId = String(opt.tariff_id);
  }
  if (discountCode.value) {
    q.discountCode = discountCode.value;
  }
  return {
    name: "nb_create_booking" as const,
    params: {
      facilityId: props.facilityId,
      facilityName: props.facilityName,
    },
    query: q,
  };
}

async function searchAvailability() {
  if (!arrivalDate.value || !departureDate.value) {
    errorMessage.value = "Please select both arrival and departure dates.";
    return;
  }
  if (!categoryId.value) {
    errorMessage.value = "Please select a category to search.";
    return;
  }
  errorMessage.value = "";
  status.value = "loading";
  results.value = [];

  try {
    const json: Record<string, string | number> = {
      period_from: arrivalDate.value + " 00:00:00",
      period_to: departureDate.value + " 23:59:59",
      category_id: categoryId.value,
      adults: adults.value,
      children: children.value,
      animals: animals.value,
    };
    if (length.value != null && length.value > 0) {
      json.length = length.value;
    }
    if (width.value != null && width.value > 0) {
      json.width = width.value;
    }
    if (equipmentLength.value != null && equipmentLength.value > 0) {
      json.equipment_length = equipmentLength.value;
    }
    if (equipmentWidth.value != null && equipmentWidth.value > 0) {
      json.equipment_width = equipmentWidth.value;
    }
    if (equipmentHeight.value != null && equipmentHeight.value > 0) {
      json.equipment_height = equipmentHeight.value;
    }
    if (slideouts.value) {
      json.slideouts = slideouts.value;
    }
    if (discountCode.value) {
      json.discount_code = discountCode.value;
    }

    const response = await api({
      url: `nb/availability/?facilityId=${props.facilityId}`,
      method: "POST",
      json,
    });

    if (response.ok) {
      results.value = (response.body.data || []) as AvailabilitySiteRow[];
    } else {
      const body = "body" in response ? response.body : undefined;
      errorMessage.value = body?.error || "Failed to fetch availability.";
    }
  } catch {
    errorMessage.value = "An error occurred while searching.";
  }

  status.value = "loaded";
}

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((arrivalDate).value = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, arrivalDate.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((departureDate).value = $event)),
              type: "date"
            }, null, 512), [
              [_vModelText, departureDate.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((categoryId).value = $event)),
              class: "form-select"
            }, [
              _createElementVNode("option", _hoisted_13, _toDisplayString(categoriesStatus.value === "loading"
                    ? "Loading categories…"
                    : "Select a category"), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: cat.category_id,
                  value: String(cat.category_id)
                }, _toDisplayString(cat.category_name), 9, _hoisted_14))
              }), 128))
            ], 512), [
              [_vModelSelect, categoryId.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((adults).value = $event)),
              type: "number",
              min: "1"
            }, null, 512), [
              [
                _vModelText,
                adults.value,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((children).value = $event)),
              type: "number",
              min: "0"
            }, null, 512), [
              [
                _vModelText,
                children.value,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((animals).value = $event)),
              type: "number",
              min: "0"
            }, null, 512), [
              [
                _vModelText,
                animals.value,
                void 0,
                { number: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((length).value = $event)),
              type: "number",
              min: "0",
              step: "0.01"
            }, null, 512), [
              [
                _vModelText,
                length.value,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((width).value = $event)),
              type: "number",
              min: "0",
              step: "0.01"
            }, null, 512), [
              [
                _vModelText,
                width.value,
                void 0,
                { number: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((discountCode).value = $event)),
              type: "text",
              placeholder: "Enter guest discount code or name"
            }, null, 512), [
              [
                _vModelText,
                discountCode.value,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((equipmentLength).value = $event)),
              type: "number",
              min: "0",
              step: "0.01",
              placeholder: "RV / rig length"
            }, null, 512), [
              [
                _vModelText,
                equipmentLength.value,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((equipmentWidth).value = $event)),
              type: "number",
              min: "0",
              step: "0.01",
              placeholder: "RV / rig width"
            }, null, 512), [
              [
                _vModelText,
                equipmentWidth.value,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((equipmentHeight).value = $event)),
              type: "number",
              min: "0",
              step: "0.01",
              placeholder: "e.g. clearance"
            }, null, 512), [
              [
                _vModelText,
                equipmentHeight.value,
                void 0,
                { number: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((slideouts).value = $event)),
              class: "form-select"
            }, _hoisted_44, 512), [
              [_vModelSelect, slideouts.value]
            ])
          ])
        ]),
        _createElementVNode("div", { class: "form-row form-row--actions" }, [
          _createElementVNode("button", {
            class: "btn btn-blue",
            type: "button",
            onClick: searchAvailability
          }, " Search Availability ")
        ])
      ]),
      (status.value === 'loading')
        ? (_openBlock(), _createBlock(BaseSpinner, {
            key: 0,
            preset: "large"
          }))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 1,
            variant: "danger",
            dismissible: "",
            onDismissed: _cache[13] || (_cache[13] = ($event: any) => (errorMessage.value = ''))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMessage.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (status.value === 'loaded' && results.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("table", _hoisted_48, [
                _hoisted_49,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(results.value, (site) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: site.site_id
                  }, [
                    _createElementVNode("td", _hoisted_50, [
                      _createElementVNode("strong", null, _toDisplayString(site.site_name || site.name || "Site " + site.site_id), 1),
                      (allSiteDetails(site).length)
                        ? (_openBlock(), _createElementBlock("details", _hoisted_51, [
                            _hoisted_52,
                            _createElementVNode("ul", _hoisted_53, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allSiteDetails(site), (detail) => {
                                return (_openBlock(), _createElementBlock("li", { key: detail }, _toDisplayString(detail), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_54, [
                      _createElementVNode("strong", null, _toDisplayString(site.category_name || site.category || "-"), 1)
                    ]),
                    _createElementVNode("td", _hoisted_55, [
                      (site.pricing_options?.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(site.pricing_options, (opt, idx) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 
                      String(opt.tariff_id ?? '') +
                      '-' +
                      String(opt.total) +
                      '-' +
                      idx
                    ,
                              class: "pricing-option"
                            }, [
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("strong", null, _toDisplayString(money(opt.total)) + " total", 1),
                                (nightlyRate(opt.total))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(money(nightlyRate(opt.total))) + " / night ", 1))
                                  : _createCommentVNode("", true),
                                (opt.title)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(opt.title), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (opt.description)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(opt.description), 1))
                                : _createCommentVNode("", true),
                              _createVNode(_component_RouterLink, {
                                class: "btn btn-sm pricing-option__book",
                                to: bookingLinkQuery(site, opt)
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_60
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          }), 128))
                        : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("strong", null, _toDisplayString(money(siteTotal(site))) + " total", 1),
                              (nightlyRate(siteTotal(site)))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(money(nightlyRate(siteTotal(site)))) + " / night ", 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode(_component_RouterLink, {
                              class: "btn btn-sm pricing-option__book",
                              to: bookingLinkQuery(site, null)
                            }, {
                              default: _withCtx(() => [
                                _hoisted_64
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (status.value === 'loaded' && !results.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_65, " No available sites found for the selected dates. "))
          : _createCommentVNode("", true)
    ])
  ]))
}
}

})